import { create } from 'zustand';
import { supabase } from '@/integrations/supabase/client';

interface NotificationStore {
  unreadMessages: number;
  pendingRequests: number;
  decrementUnread: (n: number) => void;
  fetchUnreadMessages: (userId: string) => Promise<void>;
  fetchPendingRequests: (userId: string) => Promise<void>;
}

export const useNotificationStore = create<NotificationStore>((set) => ({
  unreadMessages: 0,
  pendingRequests: 0,

  // Synchronous instant decrement — clears the badge immediately on UI
  decrementUnread: (n: number) =>
    set((state) => ({ unreadMessages: Math.max(0, state.unreadMessages - n) })),

  fetchUnreadMessages: async (userId: string) => {
    const { data: convs } = await supabase
      .from('conversations')
      .select('id')
      .or(`participant1_id.eq.${userId},participant2_id.eq.${userId}`);

    const convIds = (convs ?? []).map((c: { id: string }) => c.id);
    if (convIds.length === 0) { set({ unreadMessages: 0 }); return; }

    const { count } = await supabase
      .from('messages')
      .select('*', { count: 'exact', head: true })
      .in('conversation_id', convIds)
      .neq('sender_id', userId)
      .eq('is_read', false);

    set({ unreadMessages: count ?? 0 });
  },

  fetchPendingRequests: async (userId: string) => {
    const { count } = await supabase
      .from('friendships')
      .select('*', { count: 'exact', head: true })
      .eq('addressee_id', userId)
      .eq('status', 'pending');
    set({ pendingRequests: count ?? 0 });
  },
}));
